import { Typography, Box, Tooltip } from '@mui/material';

export default function TableMetric({
    metric,
    variant = 'inline',
}) {
    const isInline = variant === 'inline';

    return (
        <Tooltip title={metric.tooltip || ''} arrow>
            <Box
                display="flex"
                flexDirection={isInline ? 'row' : 'column'}
                alignItems="center"
                justifyContent={isInline ? 'center' : 'flex-start'}
                textAlign="center"
                px={2}
                py={1}
                sx={{
                    width: 1,
                    height: '100%',
                    gap: isInline ? 1 : 0.5,
                }}
            >
                {isInline ? (
                    <>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{ gap: 0.75, minWidth: 0 }}
                        >
                            <Box
                                sx={{
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    '& svg': { fontSize: 18 }
                                }}
                            >
                                {metric.icon}
                            </Box>

                            <Typography
                                variant="caption"
                                color="text.secondary"
                                noWrap
                                sx={{
                                    maxWidth: 140,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                }}
                            >
                                {metric.label}
                            </Typography>
                        </Box>

                        <Typography variant="caption" fontWeight={700} noWrap>
                            {metric.value}
                        </Typography>
                    </>
                ) : (
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="flex-start"
                        sx={{
                            width: '100%',
                            height: '100%',
                            minWidth: 0,
                        }}
                    >
                        {/* Header row */}
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            sx={{
                                gap: 0.75,
                                minHeight: 20,
                                mb: 0.75,
                            }}
                        >
                            <Box
                                sx={{
                                    color: 'text.secondary',
                                    display: 'flex',
                                    alignItems: 'center',
                                    '& svg': { fontSize: 18 }
                                }}
                            >
                                {metric.icon}
                            </Box>

                            <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{
                                    lineHeight: 1.1,
                                }}
                            >
                                {metric.label}
                            </Typography>
                        </Box>

                        {/* Value row */}
                        <Box
                            sx={{
                                minHeight: 34,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography
                                variant="h6"
                                fontWeight={700}
                                sx={{
                                    lineHeight: 1.2,
                                    whiteSpace: 'normal',
                                    wordBreak: 'break-word',
                                }}
                            >
                                {metric.value}
                            </Typography>
                        </Box>

                        {/* Subvalue row - reserve space even when empty */}
                        <Box
                            sx={{
                                minHeight: 20,
                                mt: 0.25,
                                display: 'flex',
                                alignItems: 'flex-start',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    lineHeight: 1.15,
                                    visibility: metric.subvalue ? 'visible' : 'hidden',
                                }}
                            >
                                {metric.subvalue || '—'}
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        </Tooltip>
    );
}